import ChartBar from './component';

export default ChartBar;
